












































import Vue from 'vue';
import ApiKeyLoader from './components/ApiKeyLoader.vue';
import UserSelector from './components/UserSelector.vue';
import DealSelector from './components/DealSelector.vue';
import DealActions from './components/DealActions.vue';
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

export default Vue.extend({
  name: 'App',
  components: {
    ApiKeyLoader,
    UserSelector,
    DealSelector,
    DealActions
  },
  data() {
    return {
      apiKeyLoaded: false,
    }
  },
  methods: {

  },
  mounted() {
    // this.loadUsers()
  }
});
